<div class="recipe-image" [class.no-image]="!recipe.photoUrl || settings.disableRecipePhotos || !recipe.usePhoto">
  <span class="back btn" (click)="goBack()">
    <span class="icon-angle-left"></span>
  </span>
  <span class="menu btn" (click)="openMenu()">
    <span class="icon-burger-thin"></span>
  </span>
  @if (recipe.photoUrl && !settings.disableRecipePhotos) {
    <img [src]="storageUrl + '/' + recipe.photoUrl" />
  }
</div>

<div class="recipe-details">
  <h1 class="name">
    {{ recipe.name }}
  </h1>

  @if (settings.showRecipeYield) {
    <div class="portion-size">{{ recipe.portionSize }}{{ recipe.portionMeasure }} per portion</div>
  }

  @if (settings.showPrices && recipe.displayFoodPortalPrice && recipe.foodPortalPrice) {
    <span class="price">
      {{ recipe.foodPortalPrice | currency: "GBP" }}
    </span>
  }

  <div class="diet-types">
    @if (recipe.isVegetarian) {
      <span class="diet">
        <span class="icon-diet-vegetarian"></span>
        <span>Vegetarian</span>
      </span>
    }
    @if (recipe.isVegan) {
      <span class="diet">
        <span class="icon-diet-vegan"></span>
        <span>Vegan</span>
      </span>
    }
    @if (recipe.isHalal) {
      <span class="diet">
        <span class="icon-halal"></span>
        <span>Halal</span>
      </span>
    }
    @if (recipe.isKosher) {
      <span class="diet">
        <span class="icon-kosher"></span>
        <span>Kosher</span>
      </span>
    }
    @if (recipe.isGlutenFree) {
      <span class="diet">
        <span class="icon-gluten-free"></span>
        <span>Gluten-free</span>
      </span>
    }
  </div>

  @if (!!recipe.tagIds.length) {
    <div class="tags">
      @for (tagId of recipe.tagIds; track tagId) {
        <span class="tag">
          {{ tagName(tagId) }}
        </span>
      }
    </div>
  }

  @if (showRecipeContainsAllergenWarning()) {
    <div class="allergy-warning">
      <div class="description">
        <span>This dish contains one or more prohibited allergens.</span>
      </div>
    </div>
  }

  @if (showRecipeMayContainAllergenWarning()) {
    <div class="allergy-warning">
      <div class="description">
        <span>This dish may contain one or more prohibited allergens.</span>
      </div>
    </div>
  }

  @if (showRecipeMissingAllergensWarning()) {
    <div class="allergy-warning">
      <div class="description">
        <span>Allergen information for this dish is missing for one or more of your allergies.</span>
      </div>
    </div>
  }

  @if (settings.showRecipeDescriptions) {
    <div class="description">{{ recipe.description }}</div>
  }

  @if (recipe.showAllergenData) {
    <div class="section">
      <div class="allergen-wrapper">
        <div class="label">
          This dish
          <b>contains</b>
          the following allergens:
        </div>
        @if (containAllergens.length) {
          <div class="allergens-list">
            @for (allergen of containAllergens; track allergen) {
              <span class="allergen-item">
                <img class="allergen-icon" [src]="'assets/allergens/allergen-' + allergen + '.svg'" />
                <span class="allergen-label">{{ allergenName(allergen) }}</span>

                @if (showSubAllergenList(allergen, 1)) {
                  <div class="sub-allergen">
                    <span class="allergen-label" style="font-weight: normal">
                      ({{ subAllergensByValue(allergen, 1) }})
                    </span>
                  </div>
                }
              </span>
            }
          </div>
        }
        @if (!containAllergens.length) {
          <div class="no-allergens">None</div>
        }
      </div>

      @if (mayContainAllergens.length) {
        <div class="allergen-wrapper">
          <div class="label">
            This dish
            <b>may contain*</b>
            the following allergens:
          </div>

          @if (mayContainAllergens.length) {
            <div class="allergens-list">
              @for (allergen of mayContainAllergens; track allergen) {
                <span class="allergen-item">
                  <img class="allergen-icon" [src]="'assets/allergens/allergen-' + allergen + '.svg'" />
                  <span class="allergen-label">{{ allergenName(allergen) }}</span>

                  @if (showSubAllergenList(allergen, 2)) {
                    <div class="sub-allergen">
                      <span class="allergen-label" style="font-weight: normal">
                        ({{ subAllergensByValue(allergen, 2) }})
                      </span>
                    </div>
                  }
                </span>
              }
            </div>
          }
          <div class="meaning">
            * Trace amounts of an allergen present as a result of cross-contamination that may occur during food
            production.
          </div>
          @if (!mayContainAllergens.length) {
            <div class="no-allergens">None</div>
          }
        </div>
      }
    </div>
  }

  @if (showNutritionData) {
    <div class="section nutrition">
      @if (recipe.ppdsInfoHtml) {
        <div class="section ppds">
          <span><b>Ingredients:</b></span>
          @if (recipe.ppdsInfoHtml) {
            <span class="ppds-data" [innerHtml]="recipe.ppdsInfoHtml"></span>
          }
        </div>
      }

      @if (recipe.showNutrientData) {
        <div class="section nutrition">
          <div class="nutrition-wrapper">
            <div class="label">1 x {{ recipe.portionSize }}{{ recipe.portionMeasure }} portion contains:</div>
            <div class="nutrition-list">
              <div class="nutrition-item energy">
                <span class="nutrition-label">Energy</span>
                <span class="value">
                  <span>{{ recipe.nutrition.kj }}kJ</span>
                  <span>{{ recipe.nutrition.kcal }}kcal</span>
                </span>
                <div class="percents">
                  {{ getNutritionPercentage("kcal") | percent }}
                </div>
              </div>
              <div
                class="nutrition-item"
                [ngClass]="recipe.nutrition.getNutritionColorCoding('fat', recipe.portionSize)">
                <span class="nutrition-label">Fat</span>
                <span class="value">{{ recipe.nutrition.fat }}g</span>
                <div class="percents">
                  {{ getNutritionPercentage("fat") | percent }}
                </div>
              </div>
              <div
                class="nutrition-item"
                [ngClass]="recipe.nutrition.getNutritionColorCoding('fatOfWhichSaturates', recipe.portionSize)">
                <span class="nutrition-label">Saturates</span>
                <span class="value">{{ recipe.nutrition.fatOfWhichSaturates }}g</span>
                <div class="percents">
                  {{ getNutritionPercentage("fatOfWhichSaturates") | percent }}
                </div>
              </div>
              <div
                class="nutrition-item"
                [ngClass]="recipe.nutrition.getNutritionColorCoding('carbohydrateOfWhichSugars', recipe.portionSize)">
                <span class="nutrition-label">Sugars</span>
                <span class="value">{{ recipe.nutrition.carbohydrateOfWhichSugars }}g</span>
                <div class="percents">
                  {{ getNutritionPercentage("carbohydrateOfWhichSugars") | percent }}
                </div>
              </div>
              <div
                class="nutrition-item"
                [ngClass]="recipe.nutrition.getNutritionColorCoding('salt', recipe.portionSize)">
                <span class="nutrition-label">Salt</span>
                <span class="value">{{ recipe.nutrition.salt }}g</span>
                <div class="percents">
                  {{ getNutritionPercentage("salt") | percent }}
                </div>
              </div>
            </div>

            <div class="label">
              <span>
                <b>% of daily reference intake ({{ currentRip.name }})</b>
                @if (hasMultipleProfiles()) {
                  <span class="change-profile btn" (click)="showRips()">Change profile...</span>
                }
              </span>
              <span>
                Typical values per 100{{ recipe.portionMeasure }}: Energy {{ kjPer100 }} kJ, {{ kcalPer100 }} kcal
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <div [class.open]="ripsMenuVisible" class="profile-menu">
    <header>Select a Reference Intake Profile...</header>

    <span class="close btn icon-status-cross" (click)="ripsMenuVisible = false"></span>

    <div class="options">
      @for (profile of settings.referenceIntakeProfiles; track profile) {
        <div class="btn" (click)="selectRiProfile(profile)">
          {{ profile.name }}
        </div>
      }
    </div>
  </div>

  @if (showNutritionData) {
    <div class="section">
      <table class="back-of-box">
        <thead>
          <tr>
            <th class="header">Nutritional information</th>
            <th class="header">per 100g</th>
            <th class="header">per portion (% RI)</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <th>Energy (kJ)</th>
            <td>{{ kjPer100 | number: "1.0-0" }}</td>
            <td>{{ recipe.nutrition.kj | number: "1.0-0" }} ({{ getNutritionPercentage("kj") | percent }})</td>
          </tr>
          <tr>
            <th>Energy (kcal)</th>
            <td>{{ kcalPer100 | number: "1.0-0" }}</td>
            <td>{{ recipe.nutrition.kcal | number: "1.0-0" }} ({{ getNutritionPercentage("kcal") | percent }})</td>
          </tr>
          <tr>
            <th>Carbohydrates (g)</th>
            <td>{{ carbPer100 | number: "1.0-1" }}</td>
            <td>
              {{ recipe.nutrition.carbohydrate | number: "1.0-1" }} ({{
                getNutritionPercentage("carbohydrate") | percent
              }})
            </td>
          </tr>
          <tr>
            <th>&nbsp;of which sugars (g)</th>
            <td>{{ sugarsPer100 | number: "1.0-1" }}</td>
            <td>
              {{ recipe.nutrition.carbohydrateOfWhichSugars | number: "1.0-1" }} ({{
                getNutritionPercentage("carbohydrateOfWhichSugars") | percent
              }})
            </td>
          </tr>
          <tr>
            <th>Fat(g)</th>
            <td>{{ fatPer100 | number: "1.0-1" }}</td>
            <td>{{ recipe.nutrition.fat | number: "1.0-1" }} ({{ getNutritionPercentage("fat") | percent }})</td>
          </tr>
          <tr>
            <th>&nbsp;of which saturates (g)</th>
            <td>{{ satPer100 | number: "1.0-1" }}</td>
            <td>
              {{ recipe.nutrition.fatOfWhichSaturates | number: "1.0-1" }} ({{
                getNutritionPercentage("fatOfWhichSaturates") | percent
              }})
            </td>
          </tr>
          <tr>
            <th>Protein (g)</th>
            <td>{{ proteinPer100 | number: "1.0-1" }}</td>
            <td>
              {{ recipe.nutrition.protein | number: "1.0-1" }} ({{ getNutritionPercentage("protein") | percent }})
            </td>
          </tr>
          <tr>
            <th>Fibre (g)</th>
            <td>{{ fibrePer100 | number: "1.0-1" }}</td>
            <td>{{ recipe.nutrition.fibre | number: "1.0-1" }} ({{ getNutritionPercentage("fibre") | percent }})</td>
          </tr>
          <tr>
            <th>Salt (g)</th>
            <td>{{ saltPer100 | number: "1.0-2" }}</td>
            <td>{{ recipe.nutrition.salt | number: "1.0-2" }} ({{ getNutritionPercentage("salt") | percent }})</td>
          </tr>
        </tbody>
      </table>
    </div>
  }

  @if (showCo2eBadge) {
    <div class="co2e-badge">
      <h2>Carbon footprint</h2>
      <piranha-co2e-badge [value]="recipe.co2eValue"></piranha-co2e-badge>
      <p>
        To help you evaluate the carbon footprint per portion, we apply an
        <b>A (very low) to E (very high)</b>
        grade range.
      </p>
      @if (!recipe.co2eValueComplete) {
        <p class="warning">Some ingredients have no CO2e data. The CO2e value may higher than the displayed value.</p>
      }
      <p><a routerLink="/home/co2e-info">Read more about CO2e values</a></p>
    </div>
  }
</div>
